export default {
  // Sidebar Navigation
  sidebar: {
    dashboard: "Dashboard",
    recommendations: "Raccomandazioni",
    organizationDesign: "Design dell'organizzazione",
    talentPool: "Pool di talenti",
    reports: "Rapporti",
    notifications: "Notifiche",
    switchOrg: "Cambia organizzazione"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relazione aggiunta con successo",
    relationshipRemovedSuccessfully: "Relazione rimossa con successo",
    relationshipSavedSuccessfully: "Relazione salvata con successo",
    profileCard: "Scheda profilo",
    viewOptions: {
      plan: "Piano",
      hierarchy: "Gerarchia",
      network: "Rete"
    },
    searchPlaceholder: "Cerca utenti...",
    networkSearchPlaceholder: "Cerca rete...",
    hierarchySearchPlaceholder: "Cerca gerarchia...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Crea",
      roleCreatedSuccessfully: "Ruolo creato con successo",
      delete: "Elimina",
      roleDeletedSuccessfully: "Ruolo eliminato con successo",
      addProfile: "Aggiungi profilo",
      profileAddedSuccessfully: "Profilo aggiunto con successo",
      removeProfile: "Rimuovi profilo",
      profileRemovedSuccessfully: "Profilo rimosso con successo",
      roleUpdate: "Aggiornamento ruolo",
      updatedSuccessfully: "Aggiornato con successo",
      profileUpdate: "Aggiornamento profilo",
      profileUpdatedSuccessfully: "Profilo aggiornato con successo"
    },
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Domande Frequenti",
    question1: "Come gestisco le impostazioni della mia organizzazione?",
    question2: "Come posso invitare nuovi membri alla mia organizzazione?",
    question3: "Quali sono i diversi ruoli utente e le autorizzazioni?",
    question4: "Come personalizzo il branding della mia organizzazione?",
    helpText: "Questo è un testo di aiuto di esempio. Si prega di contattare il supporto per assistenza specifica con le impostazioni e la configurazione della vostra organizzazione."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Nome dell'organizzazione",
    organizationUsername: "Nome utente dell'organizzazione",
    website: "Sito web",
    workEmail: "Email di lavoro",
    location: "Posizione",
    organizationType: "Tipo di organizzazione",
    primaryThemeColor: "Colore tema primario",
    secondaryThemeColor: "Colore tema secondario",
    about: "Informazioni",
    saveChanges: "Salva modifiche",
    usernameExists: "Questo nome utente esiste già",
    usernameAvailable: "Questo nome utente è disponibile",
    organizationTypeOptions: {
      business: "Azienda",
      academic: "Accademico",
      recruiter: "Reclutatore"
    },
    logo: {
      adjustTitle: "Regola logo organizzazione",
      save: "Salva",
      uploadButton: "Carica logo",
      incorrectFileType: "Tipo di file non corretto",
      incorrectFileTypeText: "Carica un tipo di file immagine supportato, es. jpg, png, ecc.",
      fileSizeExceeded: "Dimensione file immagine superata",
      fileSizeExceededText: "La dimensione dell'immagine del profilo deve essere inferiore a 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Seleziona",
    acceptInvitation: "Accetta invito",
    noOrganizationFound: "Nessuna organizzazione trovata!",
    noOrganizationSubtext: "Crea prima la tua organizzazione.",
    createOrganization: "Crea organizzazione"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Bentornato! 👋",
    setupComplete: "Setup completato!",
    setupProgress: "Setup: {step} di 4",
    copyLink: "Copia link",
    linkCopied: "Link copiato",
    criticalRoles: "Ruoli critici",
    talentPool: "Pool di talenti",
    integrations: "Integrazioni",
    onboarding: "Onboarding",
    activeCandidates: "Candidati attivi",
    connectedApps: "App connesse",
    pendingOnboards: "Onboarding in attesa",
    kvdrReportsCenter: "Centro report KVDR",
    kvdrReportsDescription: "Immergiti nei tuoi report di dati visivi chiave e ottieni insight critici.",
    exploreReports: "Esplora report >",
    talentPoolExplorer: "Esploratore pool talenti",
    talentPoolDescription: "Scopri, analizza e gestisci i tuoi migliori talenti con insight completi.",
    exploreTalentPool: "Esplora pool talenti >",
    thisMonth: "questo mese",
    goToOnboarding: "Vai all'onboarding"
  },

  // Reports
  reports: {
    title: "Report",
    nineCellMatrix: "Matrice nove celle",
    xyPlot: "Grafico XY",
    talentScoreCard: "Scheda punteggio talenti",
    emptyReports: "Report vuoti",
    createKVDRFirst: "Crea prima un KVDR e pianifica per vedere i report",
    // XY Plot specific
    xAxis: "Asse X",
    yAxis: "Asse Y",
    bubbleSize: "Dimensione bolla",
    loadingChart: "Caricamento grafico...",
    howToReadChart: "Come leggere questo grafico",
    positioning: "Posizionamento",
    horizontalPosition: "La posizione orizzontale mostra",
    verticalPosition: "La posizione verticale mostra",
    bubbleRepresentation: "Rappresentazione bolle",
    eachBubbleRepresents: "Ogni bolla rappresenta un dipendente",
    sizeIndicates: "La dimensione indica",
    quadrants: "Quadranti",
    topLeft: "Alto-Sinistra",
    topRight: "Alto-Destra",
    bottomLeft: "Basso-Sinistra",
    bottomRight: "Basso-Destra",
    low: "Basso",
    high: "Alto",
    interaction: "Interazione",
    hoverOverBubble: "Passa sopra una bolla",
    revealsDetailedMetrics: "Rivela metriche dettagliate per quel dipendente",
    colorCoding: "Codifica colori",
    differentColorsHelp: "Colori diversi aiutano a distinguere i dipendenti",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Categorizzazione dipendenti con matrice nove celle",
    methodologyDescription: "Metodologia standardizzata basata su punteggio prestazioni e prontezza successione",
    loading: "Caricamento...",
    preparingMatrix: "Preparazione matrice nove celle...",
    noDataAvailable: "Nessun dato disponibile",
    employeeAssessmentRequired: "I dati di valutazione dipendenti sono richiesti per visualizzare la matrice nove celle.",
    successionReadiness: "Prontezza successione",
    performanceScore: "Punteggio prestazioni",
    bargain: "AFFARE",
    bind: "VINCOLARE",
    backup: "BACKUP",
    onTrack: "IN CORSO",
    boost: "BOOST",
    build: "COSTRUIRE",
    bootBarter: "BOOT/BARATTO",
    employees: "Dipendenti",
    methodologyTitle: "Metodologia matrice nove celle",
    methodologySubtitle: "Categorizzazione standardizzata dipendenti basata su calcoli punteggio prestazioni e prontezza successione.",
    calculationMethod: "Metodo di calcolo",
    performanceScoreFormula: "Punteggio prestazioni (P)",
    performanceScoreCalculation: "P = 0,6 × Prestazioni + 0,4 × Valutazione",
    performanceScoreNote: "I punteggi grezzi (-1 a 1,5) sono normalizzati alla scala 0-100",
    successionReadinessFormula: "Prontezza successione (R)",
    successionReadinessCalculation: "R = 0,5 × Successione + 0,3 × Adattamento + 0,2 × Punteggio anni",
    successionReadinessNote: "I punteggi grezzi (-1 a 1,5) sono normalizzati alla scala 0-100",
    yearsScore: "Punteggio anni",
    yearsScoreCalculation: "Se Anni ≥ 3: 100, altrimenti: (Anni / 3) × 100",
    yearsScoreNote: "Attualmente usa 2 anni di default (configurabile)",
    cellCategories: "Categorie celle",
    backupDescription: "Alte prestazioni, Alta successione",
    boostDescription: "Prestazioni medie, Alta successione",
    bindDescription: "Alta/Media successione, Prestazioni basse/medie",
    onTrackDescription: "Prestazioni medie/basse, Successione media/bassa",
    buildDescription: "Prestazioni medie, Successione bassa",
    bargainDescription: "Prestazioni basse, Alta successione",
    bootBarterDescription: "Alte prestazioni, Successione bassa",
    // Talent Score Card specific
    criteria: "Criteri",
    talent: "TALENTO",
    role: "RUOLO",
    remarks: "OSSERVAZIONI",
    weightage: "Ponderazione",
    good: "Buono (8-10)",
    average: "Medio (5-7)",
    poor: "Scarso (1-4)",
    notApplicable: "Non applicabile"
  },

  // Talent Pool
  talentPool: {
    title: "Pool di talenti",
    reviewRequest: "Richiesta revisione",
    // Main talent pool
    noPendingRequest: "Nessuna richiesta in attesa trovata",
    importFrom: "Importa da",
    uploadExcel: "carica excel",
    uploadResumes: "carica currículum",
    uploadResumesTooltip: "Importare da currículums (PDF)",
    orHRIS: "o HRIS",
    pendingRequest: "Richiesta in attesa",
    allUsers: "Tutti gli utenti",
    addNewEmployee: "Aggiungi nuova scheda dipendente",
    // Table headers
    name: "Nome",
    email: "E-mail",
    maxRole: "Ruolo massimo",
    relationships: "Relazioni",
    action: "Azione",
    // User search
    searchUser: "Cerca utente",
    userNotFound: "Utente non trovato.",
    // Relationship management
    member: "Membro",
    relationship: "Relazione",
    addRelation: "Aggiungi relazione",
    removeRelationship: "Rimuovi relazione",
    // Add employee form
    firstName: "Nome",
    lastName: "Cognome",
    roleTitle: "Titolo ruolo",
    save: "Salva",
    // Profile card
    profileCard: "Scheda profilo",
    // Import
    importFromExcel: "Importa da Excel"
  },

  // Users
  users: {
    title: "Utenti",
    manageUsers: "Gestisci utenti",
    // User Recommendations
    talentRecommendations: "Raccomandazioni sui talenti",
    recommendationsDescription: "Basato sulla tua valutazione KVDR, ecco raccomandazioni personalizzate per la tua organizzazione",
    viewActivePlans: "Visualizza piani attivi",
    // Recommendation Cards
    fitmentPlan: "Piano di adattamento",
    fitmentPlanDescription: "Onboarding delle persone nei loro ruoli.",
    fitmentPlanContent: "Onboarding delle persone nei loro ruoli. Mappatura del talento giusto ai ruoli giusti con indicatori di adattamento",
    developmentPlan: "Piano di sviluppo",
    developmentPlanDescription: "Apprendimento alimentato dall'IA con ALEX",
    developmentPlanContent: "Creazione di piani di apprendimento con ALEX Percorsi di apprendimento personalizzati per aumentare il valore del talento con competenze.",
    successionPlanning: "Pianificazione della successione",
    successionPlanningDescription: "Promuovi e supporta la crescita della carriera",
    successionPlanningContent: "Promuovi e supporta la crescita della carriera Piani di coaching per la prontezza di competenze e tempo per il prossimo ruolo.",
    // Benefits Lists
    roadToRole: "Strada verso il tuo ruolo (Viaggio)",
    skillProfiling: "Profilatura delle competenze",
    learningCredits: "Crediti di apprendimento",
    marketRewards: "Ricompense di mercato",
    customLearningPaths: "Percorsi di apprendimento personalizzati",
    aiAssistedValidation: "Validazione assistita dall'IA",
    progressTracking: "Monitoraggio dei progressi con Punti Esperienza (XPs)",
    interactiveExercises: "Esercizi interattivi",
    appraisalIndicators: "Indicatori di valutazione 360°",
    goalSettingMentorship: "Impostazione degli obiettivi e mentoring",
    behaviouralCoaching: "Coaching comportamentale e piani",
    managedCareerGuidance: "Guida alla carriera gestita",
    // Action Buttons
    onboard: "Onboarding",
    activate: "Attiva",
    promote: "Promuovi",
    // Progress Section
    talentCapabilitySnapshot: "Istantanea delle capacità dei talenti",
    lastUpdated: "Ultimo aggiornamento: Oggi",
    refresh: "Aggiorna",
    // Score Labels
    industryLeader: "Leader del settore",
    highPerforming: "Alta performance",
    competitive: "Competitivo",
    developing: "In sviluppo",
    foundationBuilding: "Costruzione delle fondamenta",
    // Notifications
    alexActivated: "ALEX attivato",
    alexActivatedText: "Il tuo assistente di apprendimento IA è pronto ad aiutarti!",
    coachingRequestSent: "Richiesta di coaching inviata",
    coachingRequestSentText: "Un coach ti contatterà presto!",
    rewardsMarketplace: "Marketplace delle ricompense",
    rewardsMarketplaceText: "Esplorando ricompense e vantaggi disponibili!"
  },

  // Integrations
  integrations: {
    title: "Integrazioni",
    manageIntegrations: "Gestisci integrazioni"
  },

  // Admins
  admins: {
    title: "Amministratori",
    manageAdmins: "Gestisci amministratori"
  }
};
